var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 62C48.1208 62 62 48.1208 62 31C62 13.8792 48.1208 0 31 0C13.8792 0 0 13.8792 0 31C0 48.1208 13.8792 62 31 62Z",
    fill: "#0F7986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.264 45.5312H13.7349V46.5H48.264V45.5312Z",
    fill: "#E6E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9522 48.4375H19.0474V49.4062H42.9522V48.4375Z",
    fill: "#E6E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.512 32.4849C24.5988 32.4849 26.2906 30.7932 26.2906 28.7063C26.2906 26.6195 24.5988 24.9277 22.512 24.9277C20.4251 24.9277 18.7334 26.6195 18.7334 28.7063C18.7334 30.7932 20.4251 32.4849 22.512 32.4849Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0347 40.8622C29.0347 40.8622 29.0347 41.0387 29.0347 37.5172C29.0347 33.9956 25.1922 33.9316 25.1922 33.9316H19.8426C19.8426 33.9316 16 33.9747 16 37.5172C16 41.0387 16 40.8622 16 40.8622H29.0347Z",
    fill: "#FF3300"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7844 32.4849C41.8713 32.4849 43.563 30.7932 43.563 28.7063C43.563 26.6195 41.8713 24.9277 39.7844 24.9277C37.6976 24.9277 36.0059 26.6195 36.0059 28.7063C36.0059 30.7932 37.6976 32.4849 39.7844 32.4849Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3038 40.8622C46.3038 40.8622 46.3038 41.0387 46.3038 37.5172C46.3038 33.9956 42.4612 33.9316 42.4612 33.9316H37.1116C37.1116 33.9316 33.269 33.9747 33.269 37.5172C33.269 41.0387 33.269 40.8622 33.269 40.8622H46.3038Z",
    fill: "#FF3300"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1507 14.5572C33.2375 14.5572 34.9292 12.8654 34.9292 10.7786C34.9292 8.69173 33.2375 7 31.1507 7C29.0638 7 27.3721 8.69173 27.3721 10.7786C27.3721 12.8654 29.0638 14.5572 31.1507 14.5572Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6685 22.9344C37.6685 22.9344 37.6685 23.111 37.6685 19.5894C37.6685 16.0679 33.8259 16.0039 33.8259 16.0039H28.4764C28.4764 16.0039 24.6338 16.0469 24.6338 19.5894C24.6338 23.111 24.6338 22.9344 24.6338 22.9344H37.6685Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.0fe1ddf9.svg";
export { ForwardRef as ReactComponent };